export enum DataReviewStatusEnum {
  DATA_REVIEW_STATUS_UNSPECIFIED = 0,
  DATA_REVIEW_STATUS_PENDING = 1,
  DATA_REVIEW_STATUS_SUBMITTED = 2,
  DATA_REVIEW_STATUS_APPROVED = 3,
}
